export interface CommandTextModelCapabilities {
  supportsReasoning?: boolean;
  reasoningAlwaysOn?: boolean;
  supportsWebSearch?: boolean;
}

/**
 * Maps the canonical `aiSystem` value stored on the node
 * (e.g. "openai") to the API-side `system` field used by the
 * technologies endpoint (e.g. "openAi").
 */
const canonicalAiSystemToApiCompany: Record<string, string> = {
  openai: 'openAi',
  anthropic: 'anthropic',
  gemini: 'gemini',
  xai: 'xai',
  groq: 'groq',
  perplexity: 'perplexity',
  opensources: 'replicate',
};

export function findCommandTextModelCapabilities(
  systems: Array<{ system: string; models: Array<Record<string, unknown>> }>,
  aiSystem: string,
  modelName: string,
): CommandTextModelCapabilities | null {
  const apiCompany = canonicalAiSystemToApiCompany[aiSystem];
  if (!apiCompany || !modelName) {
    return null;
  }
  const system = systems.find(s => s.system === apiCompany);
  if (!system) {
    return null;
  }
  const model = system.models.find(m => m.model === modelName);
  if (!model) {
    return null;
  }
  return {
    supportsReasoning: model.supportsReasoning === true,
    reasoningAlwaysOn: model.reasoningAlwaysOn === true,
    supportsWebSearch: model.supportsWebSearch === true,
  };
}

export function getCommandTextReasoningVisible(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.supportsReasoning === true;
}

export function getCommandTextReasoningLockedOn(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.reasoningAlwaysOn === true;
}

export function getCommandTextWebSearchVisible(
  capabilities: CommandTextModelCapabilities | null | undefined,
): boolean {
  return capabilities?.supportsWebSearch === true;
}
